import React from 'react';
import { connect } from 'react-redux';
import { ModalPanel } from '@els/els-react--modal-panel';
import SearchTipsModalContent from '@Pages/QuickSearch/Components/BuildQuery/SearchTips/SearchTipsModalContent/SearchTipsModalContent';
import { SUMMARY_STATUS } from './constants';
import {
  getSummaryStatus as getSummaryStatusSelector,
  getSummaryResponse as getSummaryResponseSelector,
  getSummaryError as getSummaryErrorSelector,
} from './selectors';
import {
  fetchSummary as fetchSummaryAction,
  limitToReferencedDocuments as limitToReferencedDocumentsAction,
  copySummaryToClipboard as copySummaryToClipboardAction,
  resetSummaryState as resetSummaryStateAction,
} from './actions';
import useSummaryContainer from './hooks/useSummaryContainer';
import SummarySection from './components/SummarySection';
import SummaryNotAvailable from './components/SummaryNotAvailable';
import SummaryLoading from './components/SummaryLoading';
import SummaryError from './components/SummaryError';
import Summary from './components/Summary';

import './SummaryContainer.scss';

export function SummaryContainer({
  activeBreadcrumb,
  params,
  metadata,
  resetResultsScrollTop,
  summaryStatus,
  summaryResponse,
  summaryError,
  fetchSummary,
  limitToReferencedDocuments,
  copySummaryToClipboard,
  resetSummaryState,
}) {
  const { isSummarySectionVisible, isSummaryAvailable, howItWorksPanelVisible, toggleHowItWorksPanel } = useSummaryContainer({
    activeBreadcrumb,
    params,
    summaryStatus,
    fetchSummary,
    resetSummaryState,
  });

  if (!isSummarySectionVisible) {
    return null;
  }

  return (
    <>
      {howItWorksPanelVisible && (
        <ModalPanel
          panelPosition="right"
          modalProps={{
            onClose: toggleHowItWorksPanel,
          }}
          className="c-els-modal--panel-custom">
          <SearchTipsModalContent withExamplesLinks={false} />
        </ModalPanel>
      )}
      <SummarySection aria-live="polite" aria-busy={summaryStatus === SUMMARY_STATUS.LOADING}>
        {!isSummaryAvailable ? (
          <SummaryNotAvailable toggleHowItWorksPanel={toggleHowItWorksPanel} />
        ) : (
          <>
            {summaryStatus === SUMMARY_STATUS.LOADING && <SummaryLoading />}
            {summaryStatus === SUMMARY_STATUS.ERROR && (
              <SummaryError error={summaryError} fetchSummary={fetchSummary} activeBreadcrumb={activeBreadcrumb} params={params} />
            )}
            {summaryStatus === SUMMARY_STATUS.SUCCESS && (
              <Summary
                summaryResponse={summaryResponse}
                limitToReferencedDocuments={limitToReferencedDocuments}
                copySummaryToClipboard={copySummaryToClipboard}
                toggleHowItWorksPanel={toggleHowItWorksPanel}
                resetResultsScrollTop={resetResultsScrollTop}
                activeBreadcrumb={activeBreadcrumb}
                params={params}
                metadata={metadata}
              />
            )}
          </>
        )}
      </SummarySection>
    </>
  );
}

const mapStateToProps = (state, { params }) => ({
  summaryStatus: getSummaryStatusSelector(state, params),
  summaryResponse: getSummaryResponseSelector(state, params),
  summaryError: getSummaryErrorSelector(state, params),
});

const mapDispatchToProps = {
  fetchSummary: fetchSummaryAction,
  limitToReferencedDocuments: limitToReferencedDocumentsAction,
  copySummaryToClipboard: copySummaryToClipboardAction,
  resetSummaryState: resetSummaryStateAction,
};

export default connect(mapStateToProps, mapDispatchToProps)(SummaryContainer);
